<template>
  <ss-modal
    v-if="isModalVisible"
    title="Title"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot = "modal-header">
      {{ isEdit ? 'Edycja święta' : 'Nowe święto' }}
      <i class="close" @click="modalClose(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <d-row>
        <d-col>
          <ss-input
            v-model="holiday.name"
            name="name"
            label="Nazwa święta" />
          </d-col>
        <d-col>
          <label>Data święta</label>
          <ss-date
            type="text"
            name="holiday_date"
            v-model="holiday.holiday_date"
            @click="lar_errors.clear('holiday_date')"
            :class="{'is-invalid' : lar_errors.has('holiday_date')}"
            placeholder=""/>
          <div
            class="invalid-feedback"
            v-text="lar_errors.get('holiday_date')">
          </div>
        </d-col>
      </d-row>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="modalClose(false)"
        :class="{ disabled : actionInProgress }"
        :disabled="actionInProgress"
        theme="danger">
        Zamknij
      </d-button>
      <d-button
        @click.prevent="saveHoliday"
        :class="{ isLoading: actionInProgress }"
        theme="success"
        :disabled="actionInProgress"
        class="ml-3">
        Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>


<script>
import Vue from 'vue';
import SsModal from '@/components/common/SsModal';
import SsDate from '@/components/common/SsDate'
import FormUtils from '@/utils/FormUtils.js';
import LarErrors from '@/helpers/Errors';

export default {
  name: 'HolidayModal',
  components: {
    SsModal,
    SsDate,
    LarErrors
  },
  props: {
    holidayToEdit: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEdit () {
      return this.holidayToEdit && this.holidayToEdit.id;
    }
  },
  watch: {
    holidayToEdit: {
      handler: function(to) {
        if (!to || !to.id) {
          this.holiday = {
            id: null,
            name: '',
            holiday_date: ''
          }
          return;
        }

        this.holiday = to;
      },
      deep: true
    },
    show(to) {
      this.isModalVisible = to;
    },
  },
  data () {
    return {
      actionInProgress: false,
      holiday: {
        holiday_date: '',
        id: null,
        name: ''
      },
      isModalVisible: false,
      lar_errors: LarErrors
    }
  },
  mounted () {
    this.isModalVisible = this.show;
    if (this.holidayToEdit && this.holidayToEdit.id) {
      this.holiday = this.holidayToEdit;
    }
  },
  methods: {
    saveHoliday () {
      Vue.set(this, 'actionInProgress', true);

      let endpointUrl = this.holiday.id ? ('api/holidays/update/' + this.holiday.id) : 'api/holidays/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: this.holiday,
        successTitle: 'Święto zostało zapisane.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisywanie święta nie powiodło się. Spróbuj ponownie.',
        successAction: (response) => {
          this.holidayReset();
          this.modalClose(true, response.data);
        },
        failAction: (error) => {
          console.log(error);
          LarErrors.record(error.data.errors)
        }
      });

      Vue.set(this, 'actionInProgress', false);
    },
    holidayReset () {
      this.holiday = {
        id: null,
        name: '',
        holiday_date: ''
      }
    },
    modalClose (shoudlReload, newHoliday = null) {
      this.$bus.$emit('holiday-modal-hide', shoudlReload, newHoliday);
    }
  }
}
</script>
